import JwtDecode,{jwtDecode, JwtPayload} from "jwt-decode";

// Define a type for the JWT payload that includes the role field
interface CustomJwtPayload extends JwtPayload {
  role?: string;  // The 'role' might be optional, depending on how your backend generates the token
}

// Function to extract the role from the JWT token
export const getRoleFromToken = (token: string): string | null => {
  try {
    // Decode the JWT token
   
    const decoded = jwtDecode<CustomJwtPayload>(token);
     
   
    // Extract role from the decoded token (check the field your backend uses for role)
    const role = (decoded as any)['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? null; // Return null if the role is not present

    return role;
  } catch (error) {
    console.error("Failed to decode token or extract role:", error);
    return null;  // Return null if token decoding fails
  }
};
